import styles from '../../styles/ads.module.scss';
import PropTypes from 'prop-types';
import Vip from './[id]';

const VipAdditionalInfoTable = ({ data }) => {
  const {
    diseases,
    therapy,
    medicins,
    surgeries,
    food,
    howManyMeals,
    cigarettes,
    supplements,
  } = data;
  console.log('VipAdditionalInfoTable data:', data);
  return (
    <div className="table-wrapper">
      <table
        style={{ width: '100%' }}
        className={`${styles.table} grayTheme mobNoScroll`}
      >
        <thead>
          <tr>
            <th>Dodatne informacije</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              Da li trenutno imate bilo kakvih zdravstvenih problema ili
              bolesti?
            </td>
            <td>
              <span className={diseases ? 'active' : 'inactive'}>
                {diseases ? 'Da' : 'Ne'}
              </span>
            </td>
          </tr>
          <tr>
            <td>Da li koristite bilo kakve medicinske terapije?</td>
            <td>
              <span className={therapy ? 'active' : 'inactive'}>
                {therapy ? 'Da' : 'Ne'}
              </span>
            </td>
          </tr>
          <tr>
            <td>Da li koristite lekove svakodnedno?</td>
            <td>
              <span className={medicins ? 'active' : 'inactive'}>
                {medicins ? 'Da' : 'Ne'}
              </span>
            </td>
          </tr>
          <tr>
            <td>
              Da li ste ikada imali ozbiljnije operacije ili hirurške zahvate?
            </td>
            <td>
              <span className={surgeries ? 'active' : 'inactive'}>
                {surgeries ? 'Da' : 'Ne'}
              </span>
            </td>
          </tr>
          <tr>
            <td>Kako se hranite (korigovano-uobičajeno)?</td>
            <td>
              {food}
            </td>
          </tr>
          <tr>
            <td>Koliko puta jedete u toku dana?</td>
            <td>{howManyMeals}</td>
          </tr>
          <tr>
            <td>Da li konzumirate cigarete?</td>
            <td>
              <span className={cigarettes ? 'active' : 'inactive'}>
                {cigarettes ? 'Da' : 'Ne'}
              </span>
            </td>
          </tr>
          <tr>
            <td>Da li koristite dodatke ishrani? Ako da, koje?</td>
            <td>{supplements}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default VipAdditionalInfoTable;

VipAdditionalInfoTable.propTypes = {
  data: PropTypes.shape({
    diseases: PropTypes.bool,
    therapy: PropTypes.bool,
    medicins: PropTypes.bool,
    surgeries: PropTypes.bool,
    food: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    howManyMeals: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    cigarettes: PropTypes.bool,
    supplements: PropTypes.string,
  }).isRequired,
};

VipAdditionalInfoTable.defaultProps = {
  data: {
    diseases: false,
    therapy: false,
    medicins: false,
    surgeries: false,
    food: '-',
    howManyMeals: '-',
    cigarettes: false,
    supplements: '-',
  },
};
